<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">经销商库存提报</h3>
    <affix>
      <div class="tools">
        <form-button name="提交" icon="form-advance" @click="changeStatus(1)" />
        <form-button name="保存" type="primary" @click="changeStatus(0)" />
      </div>
    </affix>

    <div class="form-container">
      <el-form inline size="mini" label-width="100px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="填报人">
              <el-input
                v-model="conditions.createdByName"
                placeholder="自动生成"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="填报人部门">
              <el-input
                v-model="conditions.department"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="填报日期">
              <el-input
                v-model="conditions.createdDate"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="起始日期">
              <el-date-picker
                v-model="conditions.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="conditions.endDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                placeholder="请输入"
                resize="none"
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="明细"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
          <table-button name="add" tip="增加" @click="tableEvent('add')" />
          <table-button name="delete" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="332"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <!-- <el-input
                v-if="
                  gridOptions.columnsFieldTypes[item.field] == 'input' &&
                    item.field === 'saleCenterName'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                suffix-icon="el-icon-more"
                @focus="openDialog($event, '营销中心', row)"
              /> -->
              <el-select
                v-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' &&
                    item.field === 'saleCenter'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item2 in row.saleCenterOptions"
                  :key="item2.zzfld00001h"
                  :value="item2.zzfld00001h"
                  :label="item2.mc_short"
                />
              </el-select>
              <!-- <el-input
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'input' &&
                    item.field === 'customerName'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
                suffix-icon="el-icon-more"
                @focus="openDialog($event, '客户选择', row)"
              /> -->
              <wly-input
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'input' &&
                    item.field === 'customerCode'
                "
                v-model="row[item.field]"
                input-type="customer"
                @enter="handleEnter(...arguments, row)"
                @handleSuffixClick="openDialog($event, '客户选择', row)"
              />
              <el-input
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
              />
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'planType'
                "
                v-model="row[item.field]"
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0002']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' &&
                    item.field === 'stockType'
                "
                v-model="row[item.field]"
                filterable
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0019']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />

        <client-select v-else-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
// import { apiFindAllClientInfo } from '@/api/common'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import {
  saveStockReport,
  deleteStockReportSub,
  findStockReportByCode
} from '@/api/applyForGoods/index'
import { mapGetters } from 'vuex'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')

const rules = {
  invoiceNo: [{ required: true, message: '请选择制票通知单', trigger: 'change' }]
}

export default {
  components: {
    ClientSelect,
    OrgSelect
  },
  data() {
    return {
      rules,
      showDialog: false,
      dialogTitle: '客户选择',
      loading: false,
      conditions: {
        createdByName: '',
        department: '',
        createdDate: '',
        startDate: '',
        endDate: '',
        status: 0
      },
      validRules: {},
      selectDataOptions: {},
      currentRow: {},
      saleList: [],
      billCode: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
          {
            label: '新增',
            type: 'add',
            icon: 'icon-add',
            style: 'primary'
          },
          {
            label: '删除',
            type: 'delete',
            icon: 'icon-delete',
            style: 'default'
          }
        ],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'saleCenter',
            title: '营销中心',
            width: 100,
            slots: { default: 'saleCenter' }
          },
          {
            field: 'customerCode',
            title: '订单客户编码',
            width: 100,
            slots: { default: 'customerCode' }
          },
          {
            field: 'customerName',
            title: '订单客户名称',
            width: 100
          },
          { field: 'planType', title: '计划类型', slots: { default: 'planType' }},
          { field: 'stockType', title: '存货分类', slots: { default: 'stockType' }},
          { field: 'inQuantity', title: '本周流入量', slots: { default: 'inQuantity' }},
          { field: 'outQuantity', title: '本周流出量', slots: { default: 'outQuantity' }},
          { field: 'stockQuantity', title: '实际库存量', slots: { default: 'stockQuantity' }},
          {
            field: 'nondeliveryQuantity',
            title: '打款未到货数量',
            slots: { default: 'nondeliveryQuantity' }
          },
          { field: 'remark', title: '备注', slots: { default: 'remark' }}
        ],
        data: [],
        columnsFieldTypes: {
          saleCenter: 'select',
          customerCode: 'input',
          planType: 'select',
          stockType: 'select',
          inQuantity: 'input',
          outQuantity: 'input',
          stockQuantity: 'input',
          nondeliveryQuantity: 'input',
          remark: 'input'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return this.conditions.status === 1
    }
  },
  created() {
    if (this.$route.query.code) {
      this.billCode = this.$route.query.code
      this.initDetail()
    } else {
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.conditions.createdByName = this.userInfo.name
      this.conditions.department = this.userInfo.deptName
    }
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0002')
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
  },
  methods: {
    initDetail() {
      this.loading = true
      findStockReportByCode({ billCode: this.billCode })
        .then(res => {
          if (res?.status === 1) {
            Object.assign(this.conditions, res.data)
            this.gridOptions.data = res.data.list
          }
        })
        .catch(() => (this.loading = false))
        .finally(() => (this.loading = false))
    },
    changeStatus(type) {
      const params = {
        type,
        ...this.conditions,
        list: [...this.gridOptions.data]
      }
      this.loading = true
      delete params.status
      saveStockReport(params)
        .then(res => {
          if (res?.status === 1) {
            Object.assign(this.conditions, res.data)
            this.gridOptions.data = res.data.list
            this.$message.success('操作成功！')
          } else {
            this.$message.error('操作失败！')
          }
        })
        .catch(() => (this.loading = false))
        .finally(() => (this.loading = false))
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
    },
    openDialog(e, title, row) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
      this.currentRow = row
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.currentRow.customerName = data.customerName
        this.currentRow.customerCode = data.customerCode
        this.currentRow.saleCenterOptions = data.orgList
      } else {
        this.currentRow.saleCenterName = data.name
        this.currentRow.saleCenter = data.code
      }
      this.showDialog = false
    },
    tableEvent(btn) {
      if (btn === 'add') {
        this.insertData()
      } else {
        this.removeData()
      }
    },
    insertData() {
      const data = {
        id: '',
        saleCenterName: '',
        saleCenter: '',
        saleCenterOptions: [],
        customerName: '',
        customerCode: '',
        planType: '',
        // stockTypeOptions: []
        stockType: '',
        inQuantity: '',
        outQuantity: '',
        stockQuantity: '',
        nondeliveryQuantity: '',
        remark: ''
      }
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      const hasIds = checkedList.filter(v => v.id)

      if (hasIds.length) {
        const ids = hasIds.map(v => v.id).join(',')
        await deleteStockReportSub({ ids })
      }
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.currentRow = row

      this.currentRow.customerName = data.customerName
      this.currentRow.customerCode = data.customerCode
      this.currentRow.saleCenterOptions = data.orgList
      data.orgList.length && (this.currentRow.saleCenter = data.orgList[0].zzfld00001h)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/inventoryReport.vue